import { CallDirection } from 'calling-cross-tab-library/constants/CallDirection';
import { ConnectionTypes } from 'calling-cross-tab-library/types/ConnectionTypes';
export const getCallerHoldStatus = activeCallDetails => activeCallDetails && Boolean(activeCallDetails.isOnHold);
export const getOnHoldStartTime = activeCallDetails => activeCallDetails && activeCallDetails.onHoldStartTime;
export const getIsOutboundWidgetCall = activeCallDetails => {
  const isOutboundCall = activeCallDetails && activeCallDetails.direction === CallDirection.OUTBOUND;
  const isWidgetCall = activeCallDetails && activeCallDetails.connectionType === ConnectionTypes.EXTERNAL;
  return isOutboundCall && isWidgetCall;
};
export const getCallStartTime = activeCallDetails => activeCallDetails && activeCallDetails.callStartTime;
export const getCallId = activeCallDetails => activeCallDetails && activeCallDetails.callId;
export const getIsInboundCall = activeCallDetails => Boolean(activeCallDetails && activeCallDetails.direction === CallDirection.INBOUND);
export const getIsOutboundCall = activeCallDetails => Boolean(activeCallDetails && activeCallDetails.direction === CallDirection.OUTBOUND);
export const getIsTabCall = activeCallDetails => {
  return Boolean(activeCallDetails && activeCallDetails.connectionType === ConnectionTypes.STANDALONE_CALLING_APP);
};
export const getHasConnectionType = activeCallDetails => {
  return Boolean(activeCallDetails && !!activeCallDetails.connectionType);
};
export const getToPhoneNumberObject = activeCallDetails => activeCallDetails && activeCallDetails.toPhoneNumber;
export const getFromPhoneNumberObject = activeCallDetails => activeCallDetails && activeCallDetails.fromPhoneNumber;
export const getContactPhoneNumber = activeCallDetails => {
  if (activeCallDetails) {
    const isInboundCall = getIsInboundCall(activeCallDetails);
    const fromNumberObject = getFromPhoneNumberObject(activeCallDetails);
    const toNumberObject = getToPhoneNumberObject(activeCallDetails);
    const fromPhoneNumber = fromNumberObject && fromNumberObject.phoneNumber ? fromNumberObject.phoneNumber : undefined;
    const toPhoneNumber = toNumberObject && toNumberObject.phoneNumber ? toNumberObject.phoneNumber : undefined;
    return isInboundCall ? fromPhoneNumber : toPhoneNumber;
  }
  return undefined;
};
export const getCallRecord = activeCallDetails => activeCallDetails && activeCallDetails.record;
export const getObjectId = activeCallDetails => {
  const callRecord = getCallRecord(activeCallDetails);
  return callRecord && callRecord.objectId;
};
export const getObjectTypeId = activeCallDetails => {
  const callRecord = getCallRecord(activeCallDetails);
  return callRecord && callRecord.objectTypeId;
};
export const getCallSource = activeCallDetails => {
  return activeCallDetails && activeCallDetails.source;
};
export const getIsRecording = activeCallDetails => Boolean(activeCallDetails && activeCallDetails.isRecording);
export const getCrmObjectId = activeCallDetails => activeCallDetails && activeCallDetails.crmObjectId;
export const getRequireTwoPartyRecordingConsent = activeCallDetails => {
  if (activeCallDetails && activeCallDetails.requireTwoPartyRecordingConsent === false) {
    return false;
  } else {
    return true;
  }
};
export const getShouldShowRecordingModal = activeCallDetails => Boolean(activeCallDetails && activeCallDetails.shouldShowRecordingModal);
export const getLiveRecommendations = activeCallDetails => {
  const blankRecommendations = [];
  return activeCallDetails && activeCallDetails.liveRecommendations ? activeCallDetails.liveRecommendations : blankRecommendations;
};
export const getShouldShowOnePartyConsentRecordingAlert = activeCallDetails => Boolean(activeCallDetails && activeCallDetails.shouldShowOnePartyConsentRecordingAlert);
export const getTaskId = activeCallDetails => {
  return activeCallDetails && activeCallDetails.prospectingQueueItemId;
};
export const getCallType = activeCallDetails => {
  return activeCallDetails && activeCallDetails.callType;
};
export const getCallDisposition = activeCallDetails => {
  return activeCallDetails && activeCallDetails.callDisposition;
};
export const getCallNotes = activeCallDetails => {
  return activeCallDetails && activeCallDetails.callNotes;
};
export const getFollowUpTaskId = activeCallDetails => {
  return activeCallDetails && activeCallDetails.followUpTaskId;
};
export const getContactName = activeCallDetails => {
  return activeCallDetails && activeCallDetails.contactName;
};
export const getFirstAssociatedCompanyName = activeCallDetails => {
  return activeCallDetails && activeCallDetails.firstAssociatedCompanyName;
};
export const getThreadId = activeCallDetails => {
  return activeCallDetails && activeCallDetails.threadId;
};
export const getMessageId = activeCallDetails => {
  return activeCallDetails && activeCallDetails.messageId;
};
export const getSpeakerDeviceId = activeCallDetails => {
  return activeCallDetails && activeCallDetails.speakerDeviceId;
};
export const getMicrophoneDeviceId = activeCallDetails => {
  return activeCallDetails && activeCallDetails.microphoneDeviceId;
};
export const getEngagementUpdateStatus = activeCallDetails => activeCallDetails && activeCallDetails.engagementUpdateStatus;